import privecyBanner from '../assets/images/PrivacyPolicyImg.svg';
import termsBanner from '../assets/images/terms&conditionImg.svg';
import fraudBanner from '../assets/images/fraudAlartImg.svg';
import trustBanner from '../assets/images/trust&seftyImg.svg';
import reportBanner from '../assets/images/reportIssueImg.svg';
import helpBanner from '../assets/images/helpImg.svg';
import { Children } from 'react';
import { type } from '@testing-library/user-event/dist/type';

const sections = {
  privacy: {
    title: "Privacy Policy",
    img: privecyBanner,
    topics: [
      {
        h: "1. Introduction",
        content: [
          {
            type: "text",
            value:
              "We, at MentorX4u and our affiliated companies worldwide (collectively referred to as MentorX4u), are dedicated to respecting your online privacy and recognize the importance of protecting and managing any personally identifiable information you share with us. This Privacy Policy (Policy) describes how MentorX4u collects, uses, discloses, and transfers personal information of users through our website www.MentorX4u.com, mobile applications, and online services (collectively, the Platform). This policy applies to those who visit the Platform or whose information MentorX4u otherwise receives in connection with our services, including contact information of individuals associated with MentorX4u, such as partners (collectively referred to as Users). For the purposes of this Privacy Policy, You or Your shall refer to the individual accessing the Platform."
          },
        ]
      },

      {
        h: "2. Types of Personal Information collected by MentorX4u",
        content: [
          {
            type: "text",
            value:
              `"Personal Information" (PI) refers to any information that relates to an identified or identifiable natural person. This includes common identifiers such as name, identification number, location data, online identifiers, or any factors specific to the physical, physiological, genetic, mental, economic, cultural, or social identity of that person. At MentorX4u, we collect information about you and your usage to enhance our services and offerings. The types of Personal Information we collect and the methods of collection depend on how you interact with us. Below are the categories of Personal Information we collect in various ways:`
          },
          {
            type: "list",
            value: [
              "Registration Information: When you sign up for alerts or create an account on the Platform, we collect your name, email address, password, country, city, contact number, and the company/organization you are associated with.",

              "Profile Information: If you register on the Platform, you may provide information typically included in a resume, such as name, contact details (including email address and mobile number), work experience, educational qualifications, and current or past salary details.",

              "Service Usage Information: As a user of our services through the Platform, we collect information about how you use the services, including log information and location data.",

              "Survey Participation: If you participate in surveys or fill out forms, we may collect your Personal Information, including your name, age, contact details, and preferences.",

              "Demographic Information: We may collect information about your caste and eligibility for affirmative action programs or policies if you choose to provide it.",

              "Communication Information: When you communicate with MentorX4u or use the Platform to interact with other users (such as partners), we collect information about your communication and any details you decide to share.",

              "Technical Information: When you visit our Platform, we use cookies to automatically collect, store, and use technical information about your system and interactions with the Platform and the services you access.",

              "Affiliate Data Sharing: If you access services offered by our affiliates through the Platform, we will share your data with them in accordance with this policy. When using affiliate services, you will be governed by their terms and privacy policies, so we encourage you to review those to understand how they handle your data.",

              "Device Information: When you access the Platform via a device, we may collect technical or related information from that device, including its location.",

              "Communication Monitoring: To the extent permitted by law, MentorX4u may monitor and record your communications with us to comply with legal and regulatory obligations and internal policies, which may include recording telephone conversations.",

              "Social Media Integration: If you choose to sign in with your social media account or connect it to our services, you consent to our collection, storage, and use of the information made available through that interface, in accordance with this Privacy Policy. For more details, please refer to your social media provider's privacy policy."
            ]
          }
        ]
      },
      {
        h: "3. How MentorX4u May Use Your Personal Information",
        content: [
          {
            type: "text",
            value:
              "At MentorX4u, we will only use your personal data in a fair and reasonable manner, where we have a lawful basis to do so. The usage of your personal information will depend on how you interact with us. We may process your Personal Information for the following purposes:"
          },
          {
            type: "list",
            value: [

              "Service Provision: To provide our services and products to you, including sending job alerts, calendar notifications, relevant search results, recommended job opportunities, and other communication through social media.",

              "User Protection and Support: To protect our users and offer customer support when needed.",

              "User Experience Improvement: We utilize information collected from cookies and other technologies to enhance your user experience and the overall quality of our services. For tailored advertisements, we will not link identifiers from cookies or similar technologies with sensitive categories, such as race, religion, sexual orientation, or health.",

              "Platform Improvement: To enhance the Platform and its content, providing better features and services.",

              "Market Research: To conduct market research and surveys aimed at improving our products and services.",

              "Marketing Communications: To send you information about our products and services (including those of our affiliates) for marketing purposes and promotions.",

              "Crime Prevention and Investigation: To prevent, detect, investigate, and take action against crimes, including fraud and other financial crimes, as well as any illegal activities, suspected fraud, or violations of MentorX4u’s Terms of Use.",

              "Legal Compliance: To the extent required for identity verification, government sanctions screening, and due diligence checks.",

              "Legal Rights Protection: To establish, exercise, or defend legal rights in connection with legal proceedings, including any potential legal actions, and to seek professional or legal advice related to such proceedings."
            ]
          }
        ]
      },
      {
        h: "4. Cookies and Other Tracking Technologies",
        content: [
          {
            type: "text",
            value:
              ` MentorX4u, we utilize "cookies" and other tracking technologies on some of our web pages. A "cookie" is a small text file that helps collect information about website activity. Some cookies and similar technologies may be used to recall Personal Information that you have previously provided. Most browsers allow you to control cookies, including whether to accept them and how to remove them.

              You can configure most browsers to notify you when you receive a cookie or to block cookies entirely. However, please be aware that if you choose to delete or block cookies, you may need to re-enter your original user ID and password to access certain sections of the Platform.

              Our tracking technologies may collect information such as internet domain and host names, Internet Protocol (IP) addresses, browser software and operating system types, clickstream patterns, and the dates and times our site is accessed. By using cookies and other tracking technologies, we aim to enhance our Platform and improve the overall user experience. Additionally, we may analyze information that does not contain Personal Information for trends and statistical insights.

              For more information about our use of cookies please refer to our Cookie Policy.`
          },
          
        ]
      },
      {
        h: "5. The Basis/Grounds for Collection and Processing of Your Personal Information",
        content: [
          {
            type: "text",
            value:
              "At MentorX4u, your Personal Information is collected and processed based on the following legal grounds, which depend on the nature of the Personal Information and the purposes for which it is processed:"
          },
          {
            type: "list",
            value:["Consent:We rely on your consent to process your Personal Information in certain situations. If we require your consent to collect and process specific Personal Information, as mandated by applicable data protection laws, we will seek your consent at the time of collection. Processing will only occur after your consent has been obtained.",

            "Compliance with Legal Obligations:Your Personal Information may also be processed by MentorX4u to the extent that such processing is necessary for us to comply with legal obligations. For example, we may need to disclose your Personal Information in response to a court order or retain specific records for a required period to meet the demands of applicable laws.",
              
            ]
          }
        ]
      },
      {
        h: "6. Information Sharing and Disclosure",
        content: [
          {
            type: "text",
            value:
              "At MentorX4u, we limit access to your Personal Information to employees who reasonably need to know that information to fulfill their roles in providing, operating, developing, or improving our products or services."
          },
          {
            type: "text",
            value:
              "MentorX4u does not disclose, transfer, or share your Personal Information with others except under the following circumstances:"
          },
          {
            type: "list",
            value:["Affiliates and Group Companies: We may share your information with our affiliates and group companies as necessary for internal business, administrative purposes, and the provision of services aimed at enhancing your career.",

            "Potential Recruiters: If we determine that your resume aligns with a job vacancy, we may share your information with potential recruiters. By registering on the Platform and consenting to this Privacy Policy, you agree that MentorX4u may contact you or forward your resume to these recruiters.",

            "Legal and Regulatory Authorities: We may disclose your Personal Information to enforcement, regulatory, and judicial authorities if we believe it is necessary to respond to subpoenas, court orders, or legal processes; establish or exercise our legal rights; defend against legal claims; investigate or prevent illegal activities; or address potential threats to the safety of individuals.",

            `Business Transfers: In the event of a merger, acquisition, financing, sale of assets, or any situation involving the transfer of some or all of MentorX4u’s business assets, we may disclose Personal Information to parties involved in the negotiation or transfer.`,

            "Third-Party Service Providers: We may engage third-party service providers and marketing partners to provide services on our behalf, maintain the Platform and mailing lists, or communicate with you about offers related to our products and services. We will take reasonable steps to ensure these third parties are obligated to protect your Personal Information and adhere to appropriate confidentiality agreements.",

            "Third-Party Advertisers: We may allow third-party advertisers to display advertisements when you visit the Platform. These advertisers may use information about your visits to provide targeted advertisements. MentorX4u does not provide any Personal Information to the advertisers when you interact with or view a targeted advertisement. However, if you engage with an advertisement, the advertiser may make assumptions based on your interactions.",
              
            ]
          },
          {
            type: "text",
            value:
              "MentorX4u does not intend to transfer your Personal Information without your consent to third parties not acting on our behalf unless required by law."
          },
          {
            type: "text",
            value:
              "If your Personal Information is transferred outside India, we will take the necessary steps to protect your Personal Information in accordance with applicable data protection laws."
          },
          {
            type: "text",
            value:[
              "MentorX4u’s use and transfer to any other app of information received from Google APIs will adhere to ",{ type: "highlight", text: "Google API Services" },  " User Data Policy, including the Limited Use requirements."]
          },
        ]
      },
      {
        h: "7. Third-Party Content",
        content: [
          {
            type: "text",
            value:
              "Please be aware that the MentorX4u Platform may contain links to other sites that are not governed by this Privacy Policy. Users may be directed to third-party sites for more information, including advertisers, blogs, content sponsorships, vendor services, social networks, and more."
          },
          {
            type: "text",
            value:
              "We partner with affiliates to provide additional services related to the Platform, such as career enhancement, skill development, and interview preparation. For instance, we offer RisoHire—a service that provides resources and support to help you with your career and skill enhancement. If you access RisoHire through the MentorX4u platform, your personal data will be governed by the privacy policy of RisoHire."
          },
          {
            type: "text",
            value:[
              "You may review the privacy policy of RisoHire services ",
              {type:"link",text:"here",url:"https://Risoapp.com/services"},
              "."
            ]
          },
          {
            type: "text",
            value:
              "If your Personal Information is transferred outside India, we will take the necessary steps to protect your Personal Information in accordance with applicable data protection laws."
          },
          {
            type: "text",
            value:
              "MentorX4u does not intend to transfer your Personal Information without your consent to third parties not acting on our behalf unless required by law."
          },
        ]
      },
      {
        h: "8. Children",
        content: [
          {
            type: "text",
            value:
              "To use the MentorX4u Platform, you agree that you must be at least the minimum age described in this paragraph or older."
          },
          {
            type: "text",
            value:
              "The minimum age for these purposes shall be eighteen (18). However, if local laws require that you must be older for MentorX4u to lawfully provide the services over the Platform to you, then that older age shall apply as the applicable minimum age."
          },
          {
            type: "text",
            value:
              "If you are under the age of 18 or the age of majority in your jurisdiction, you must use the Platform under the supervision of a parent, legal guardian, or responsible adult. ",
            
          },
        ]
      },
      {
        h: "9. Retention of Personal Information",
        content: [
          {
            type: "text",
            value:
              "Your Personal Information will not be retained by MentorX4u any longer than necessary for the purposes for which it is processed and/or in accordance with legal, regulatory, contractual, or statutory obligations as applicable."
          },
          {
            type: "text",
            value:
              "At the expiry of such periods, your Personal Information will be deleted or archived in compliance with applicable laws."
          },
        ]
      },
      {
        h: "10. Controlling Your Personal Information",
        content: [
          {
            type: "text",
            value:
              "MentorX4u provides you with the ability to keep your Personal Information accurate and up-to-date. If at any time you would like to: a) rectify, update, or correct your Personal Information; b) obtain confirmation on whether or not your Personal Information is being processed; c) access your Personal Information or exercise your right to data portability; d) exercise your right to restrict the continuing disclosure of your Personal Information to any third party by MentorX4u in certain circumstances,"
          },
          {
            type: "text",
            value:
              "you are requested to contact us using the contact details mentioned in paragraph 14 below. We will require you to provide valid proof of your identity to ensure that your rights are respected."
          },
          {
            type: "text",
            value:
              "For the exercise of certain rights, you may be required to approach the relevant authority or designated officer per the provisions of the applicable data protection laws. MentorX4u may, in accordance with applicable data protection laws, charge a fee for fulfilling your request, particularly in cases of excessive or manifestly unfounded requests. Furthermore, you acknowledge that the rights mentioned above are not absolute and are subject to limitations as per applicable data protection laws."
          },
           {
            type: "text",
            value:
              "If you wish to delete your account on MentorX4u, you may do so by using the settings available in your account."
          },
        ]
      },
      {
        h: "11. Confidentiality and Security",
        content: [
          {
            type: "text",
            value:
              "The security and confidentiality of your Personal Information is important to us at MentorX4u. We have invested significant resources to protect the safekeeping and confidentiality of your personal data. When using external service providers acting as processors, we require that they adhere to the same standards as MentorX4u does. Regardless of where your Personal Information is transferred or stored, we take all reasonable steps necessary to ensure that your data is kept secure."
          },
          {
            type: "text",
            value:
              "We seek to ensure compliance with the requirements of applicable data protection laws to protect and preserve your privacy. We have implemented physical, electronic, and procedural safeguards that comply with the laws in India to protect your Personal Information. By accepting the terms of this Privacy Policy, you agree that the standards and practices being implemented by us are reasonable and sufficient for the protection of your Personal Information."
          },
        ]
      },
      {
        h: "12. Social Media",
        content: [
          {
            type: "text",
            value:
              "MentorX4u operates channels, pages, and accounts on various social media sites to inform, assist, and engage with our users. We monitor and record comments and posts made on these channels to improve our products and services."
          },
          {
            type: "text",
            value:
              "Please note that you must not communicate the following information to MentorX4u through such social media sites:"
          },
          {
            type: "list",
            value:[
              "Sensitive Personal Data: This includes any information revealing racial or ethnic origin, political opinions, religious or philosophical beliefs, trade union membership, as well as genetic data, biometric data for uniquely identifying an individual, data concerning health, or data concerning an individual's sex life or sexual orientation. Additionally, it includes other sensitive personal data such as criminal convictions, offenses, and national identification numbers.",

              "Excessive, Inappropriate, Offensive, or Defamatory Content: MentorX4u is not responsible for any information posted on these sites other than the information posted by our employees on our behalf. We are only responsible for our own use of the Personal Information received through such sites."
            ]
          },
        ]
      },
       {
        h: "13. Changes to this Privacy Policy",
        content: [
          {
            type: "text",
            value:
              "MentorX4u reserves the right to update, change, or modify this Privacy Policy at any time. Any updates, changes, or modifications will take effect from the date of publication. We encourage users to review this Privacy Policy periodically to stay informed about how we are protecting your information."
          },
        ]
      },
       {
        h: "14. Disclaimer",
        content: [
          {
            type: "text",
            value:
              "MentorX4u does not store any account-related information or any credit/debit card details. We shall not be liable for any loss or damage sustained by users as a result of any disclosure (inadvertent or otherwise) of information concerning the user’s account, credit cards, or debit cards during online transactions or payments made for any products and/or services offered through the Platform."
          },
          {
            type: "text",
            value:
              "If you share any Personal Information with MentorX4u that was not requested during registration (whether mandatorily or optionally), we will not be liable for any information security breach or disclosure concerning such information."
          },
          {
            type: "text",
            value:
              "If you have any questions regarding this Privacy Policy or the protection of your Personal Information, please contact MentorX4u’s Data Protection Officer/Grievance Officer at the following: [Contact Information]."
          },
        ]
      },
      {
        h: "15. Data Protection Officer/Grievance Officer",
        content: [
          {
            type: "text",
            value:
              "In case you have any complaints and/or grievances in relation to the processing of your Personal Information, you can send your complaints via e-mail to our Grievance Officer:"
          },
          {
           type: "list",
           value: [
                "Grievance Officer",
                "MentorX4u",
                [
                  "Email: ",
                  { type: "highlight", text: "privacy@mentorx4u.com" },
                 
                ]
              ]
          }
        ]
      },
      {
        h: "Cookie Policy",
        content:[
          {
            type:"text",
            value:""
          }
        ]
      },
      {
        h: "Introduction",
        content:[
          {
            type:"text",
            value:""
          }
        ]
      },
      {
        h: "Cookie Policy",
        content:[
          {
            type:"text",
            value:`This Cookie Policy ("Policy") explains how MentorX4u uses cookies and similar tracking technologies on our platform. We are committed to transparency and believe in being open about how we use your information. This Policy provides detailed information about how and when we use cookies on our websites and services.`
          },
          {
            type:"text",
            value:"This Cookie Policy applies to any MentorX4u product or service that links to this policy or incorporates it by reference."
          }
        ]
      },
      {
        h: "Cookie Policy",
        content:[
          {
            type:"text",
            value:`This Cookie Policy ("Policy") explains how MentorX4u uses cookies and similar tracking technologies on our platform. We are committed to transparency and believe in being open about how we use your information. This Policy provides detailed information about how and when we use cookies on our websites and services.`
          },
          {
            type:"text",
            value:"This Cookie Policy applies to any MentorX4u product or service that links to this policy or incorporates it by reference." 
          }
        ]
      },
      {
        h: "a. Does MentorX4u use cookies?",
        content:[
          {
            type:"text",
            value:`MentorX4u uses cookies, tags, and other tracking technologies when you access any of our websites, mobile sites, or mobile apps, as well as any third-party services used through the MentorX4u platform (collectively referred to as "the services"). Cookies help us ensure that you have the best possible experience while using our services, and they also contribute to keeping your account secure. By continuing to visit or use our services, you agree to the use of cookies and similar technologies for the purposes outlined in this policy. If you prefer not to receive cookies or tracking technologies, you should stop using our site or adjust your browser and third-party cookie settings as described below.`
          },
        ]
      },
      {
        h: "b. What is a cookie?",
        content:[
          {
            type:"text",
            value:`Cookies are small text files stored by a website you visit in your browser, which are then sent back by your web browser in every request to that website. A cookie file is saved in your web browser and allows MentorX4u or a third party to recognize you, making your subsequent visits easier and our services more useful to you. Essentially, cookies serve as an identification card for MentorX4u's servers. They enable MentorX4u to serve you better and more efficiently, personalizing your experience on our platform. Additionally, web beacons, tags, and scripts may be utilized on our websites or in emails to help deliver cookies, count visits, understand usage and campaign effectiveness, and determine whether an email has been opened and acted upon. We may analyze the usage of these technologies and generate reports on both an individual and aggregated basis.

            Cookies can be classified as "persistent" or "session" cookies. A persistent cookie helps us recognize you as an existing user, making it easier for you to return to MentorX4u or engage with our services without needing to sign in again. Once you sign in, a persistent cookie remains in your browser and is read by MentorX4u when you return to one of our sites or a partner site utilizing our services. In contrast, session cookies last only for the duration of your session (typically the current visit to a website or a browser session).`
          },
        ]
      },

      {
        h: "c. What are cookies used for?",
        content: [
          {
            type:"text",
            value:"When you visit MentorX4u, we may place cookies in your browser, known as First Party Cookies. These cookies help maintain session information as you navigate our site. They enable us to understand user preferences, enhance the overall experience, and track usage and statistical information. Additionally, cookies allow us to deliver personalized advertising and features. You can manage cookie settings through your browser; however, disabling cookies may limit your ability to access certain features of our website."
          },
          {
            type: "table",
            value: {
              headers: ["Category", "Description"],
              rows: [
                ["Essential Cookies", `Essential cookies (First Party Cookies) are sometimes called "strictly necessary" as without them we cannot provide many services that you need on the Website. For example, essential cookies help remember your preferences as you move around the Website. Essential cookies also keep you logged in into a website. Without them the login functionality would not work.`],
                ["Analytics Cookies", "These cookies track information about visits to the MentorX4u.com and partner (recruiter websites) websites so that we can make improvements and report our performance. For example: analyse visitor and user behaviour so as to provide more relevant content or suggest certain activities. They collect information about how visitors use the Websites, which site the user came from, the number of each user’s visits and how long a user stays on the Websites. We might also use analytics cookies to test new ads, pages, or features to see how users react to them."],
                ["Functionality or Preference Cookies", "During your visit to the Websites, cookies are used to remember information you have entered or choices you make (such as your username, language or your region) on the Websites. They also store your preferences when personalizing the Websites to optimize your use of MentorX4u.com. These preferences are remembered, through the use of the persistent cookies, and the next time you visit the Websites you will not have to set them again."],
                ["Targeting or Advertising Cookies", `These Cookies are placed by third party advertising platforms or networks or MentorX4u.com in order to, deliver ads and track ad performance, enable advertising networks to deliver ads that may be relevant to you based upon your activities (this is sometimes called "behavioural" "tracking" or "targeted" advertising) on the Websites. They may subsequently use information about your visit to target you with advertising that you may be interested in, on MentorX4u.com websites or other websites. For example, these cookies remember which browsers have visited the websites.`]
              ]
            }
          }
        ]
      },
      {
        h: "d. When does MentorX4u place cookies?",
        content:[
          {
            type:"text",
            value:`We use cookies on the MentorX4u website and mobile applications. Any browser accessing our platforms will receive cookies, allowing us to recognize you more quickly on your return visits. Cookies help us understand which pages and information you find most useful or interesting.`,
          },
          {
            type:"text",
            value:`MentorX4u may also utilize its own analytics cookies, separate from Google Analytics, to generate statistics and reports about visitor activities on our site and app.`,
          },
        ]
      },
      {
        h: "e. How are cookies used for online analytics purposes?",
        content:[
          {
            type:"text",
            value:`We may use web analytics services on MentorX4u, such as Google Analytics, to analyze how users interact with our services. These services track data, including the third-party websites from which you arrive. The information collected by these technologies is disclosed to or collected directly by the service providers, who use it to evaluate your usage of our services. Additionally, we utilize Google Analytics for various online marketing purposes, as described in the following sections.`,
          },
        ]
      },
      {
        h: "f. How are cookies used for advertising purposes?",
        content:[
          {
            type:"text",
            value:`Cookies and other advertising technologies, such as beacons, pixels, and tags, help us serve relevant ads to you more effectively. They enable us to provide aggregated auditing, research, and reporting for advertisers, improve our services, and track when content has been displayed to you. We collaborate with website analytics and advertising partners, including Google Display Network and Facebook, to deliver MentorX4u advertisements on third-party publisher websites. These partners may set cookies on your computer's web browser, allowing them to recognize your device and display MentorX4u ads across the Internet. Additionally, our analytics software measures your engagement and interactions while using MentorX4u services. This process allows ad networks to compile anonymous, de-identified information about where you, or others using your device, encountered our advertisements, whether you interacted with them, and subsequent actions taken on MentorX4u websites and applications. This information helps ad networks deliver targeted advertisements that align with your interests, and it enables MentorX4u to optimize our advertising campaigns and website usability. In essence, we use analytics data alongside data about our online ads shown through the Google Display Network, Facebook for Advertisers, or other advertising networks to understand how anonymous users interacted with our website after viewing our ads.`,
          },
        ]
      },
      {
        h: "g. What third-party cookies does MentorX4u use?",
        content:[
          {
            type:"text",
            value:`Please note that third parties, including advertising networks and providers of external services like web traffic analysis, may also use cookies on our services. The names of cookies, pixels, and other technologies may change over time. We partner with trusted companies to assist with advertising, which may place cookies on your device. Additionally, we may integrate content from social networks into our pages, such as embedded feeds from platforms like Facebook. These social networks may also set cookies on your device. For example, if you log into Facebook, Twitter, or Google via our website, a cookie will be placed on your computer, similar to logging into these social networks directly.`,
          },
          {
            type:"text",
            value:`We utilize Google Analytics on our services to help us analyze user interactions. Google Analytics employs performance cookies to track customer interactions, providing insights into which pages are viewed, popular content, peak visiting times, whether visitors are returning users, referral sources, and other related information. All data collected through these cookies is anonymized.`,
          },
          {
            type:"text",
            value:`We recommend reviewing the respective privacy policies of these external services to understand what data they collect about you and how they process it.`,
          },
          {
            type:"list",
            value:[
              ["Facebook:",{type:"link",text:"https://www.facebook.com/policy.php",url:"https://www.facebook.com/policy.php"}],

              ["AdSense:",{type:"link",text:"https://policies.google.com/technologies/ads",url:"https://policies.google.com/technologies/ads",}],

              ["Google Analytics:",
              {
                type:"link",
                text:"https://www.google.com/analytics/learn/privacy.html",
                url:"https://www.google.com/analytics/learn/privacy.html"
              }],
              ["Google Tag Manager:",
              {
                type:"link",
                text:"https://www.google.com/analytics/tag-manager/faq/",
                url:"https://www.google.com/analytics/tag-manager/faq/"
              }],
              ["Google+:",
              {
                type:"link",
                text:"https://www.google.com/policies/privacy/",
                url:"https://www.google.com/policies/privacy/",
              }],
              ["Twitter:",
              {
                type:"link",
                text:"https://twitter.com/en/privacy",
                url:"https://twitter.com/en/privacy"
              },],
              ["Google Double click:",
              {
                type:"link",
                text:"https://support.google.com/dfp_premium/answer/2839090?hl=en",
                url:"https://support.google.com/dfp_premium/answer/2839090?hl=en"
              }]
            ]
          }
        ]
      },
      {
        h: "h. What are Web Beacons?",
        content:[
          {
            type:"text",
            value:`MentorX4u occasionally advertises on third-party websites. To track the success of our advertising campaigns, we may use visitor identification technologies such as "web beacons" or "action tags," which count visitors who arrive at our site after viewing a MentorX4u advertisement on a third-party site. Our partners may also use web beacons to collect aggregated data provided by your browser while you are on our site or another site where MentorX4u is featured.`,
          },
          {
            type:"text",
            value:`By navigating on our site, you agree to the placement of cookies and web beacons on your computer or device. If you prefer not to receive web beacons, you should either stop using our site or adjust your browsing settings accordingly.`,
          },
        ]
      },
      {
        h: "i. How to Control Cookies?",
        content:[
          {
            type:"text",
            value:`Most browsers allow you to manage cookies through their settings preferences. If you choose to disable cookies, you will still see advertising on the internet, but it may not be tailored to your interests. Disabling cookies does not mean you won't receive any advertisements while online. While we have mentioned most of the third parties involved in using targeting or advertising cookies in previous sections, this list is not exhaustive and may change. Therefore, even if you disable all the third-party cookies listed, you may still receive some tailored advertisements and recommendations.`,
          },
          {
            type:"text",
            value:`There are various ways to manage the cookies set on your devices. However, essential cookies cannot be disabled. Not allowing certain cookies may limit your access to our website and affect its performance, features, or services.`,
          },
          {
            type:"text",
            value:`You can also manage cookie settings in the privacy options of your web browser. Please be aware that if you block all cookies through your browser settings, you may not be able to access certain parts of our website or others'.`,
          },
          {
            type:"text",
            value:`Changing your Cookie Settings: The browser settings for changing your cookies settings are usually found in the 'options' or 'preferences' menu of your internet browser. In order to understand these settings, the following links may be helpful. Otherwise you should use the 'Help' option in your internet browser for more details.`,
          },
          {
            type:"list",
            value:[
              {text:"Cookie settings in Internet Explorer",url:"https://support.microsoft.com/en-us/windows/manage-cookies-in-microsoft-edge-view-allow-block-delete-and-use-168dab11-0753-043d-7c16-ede5947fc64d"},
              {text:"Cookie settings in Firefox",url:"https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop?redirectslug=enable-and-disable-cookies-website-preferences&redirectlocale=en-US"},
              {text:"Cookie settings in Chrome",url:"https://support.google.com/chrome/answer/95647"},
              {text:"Cookie settings in Safari",url:"https://support.apple.com/en-in/guide/safari/sfri11471/mac"}
            ]
          },
        ]
      },
      {
        h: "",
        content:[
          {
            type:"text",
            value:["More information: To find out more about cookies, including how to see what cookies have been set and how to manage and delete them, visit",

            {type:"link",text:"www.allaboutcookies.org.",url:"https://allaboutcookies.org/"},
             "You can learn more about opting out of receiving interest-based ads from other companies at",
             {type:"link",text:"ptout.aboutads.info ",url:"https://optout.aboutads.info/"},
             "and",
             {type:"link",text:"www.networkadvertising.org/choices",url:"https://thenai.org/how-to-opt-out/"},
             ". In addition, certain third party advertising networks, like Facebook (pixels) and Google, permit users to opt out of or customize preferences associated with your internet browsing. To learn more about this feature from Google, click here. For further information about the Facebook Pixel, click",
             {type:"link",text:"here",url:"https://www.facebook.com/business/help/742478679120153?id=1205376682832142"},"."
            ]
          },
          
          
        ]
      },

    ]
  },

  terms:{
    title:"Terms & Conditions",
    img:termsBanner,
    topics:[
      {
        h:"",
        content:[
          {
            type:"text",
            value:["These terms and conditions of Use (hereinafter referred to as “Terms of Usage”) describe and govern the User’s use of the content and services offered by MentorX4u through ",{type:"link",text:"www.mentorx4u.com",url:"https://mentorx4u.com/"}, " (hereinafter referred to as “We,” “Riso,” “us,” “our,” “Riso application,” “Website”)."]
          }
        ]
      },
      {
        h:"UPDATION",
        content:[
          {
            type:"text",
            value:"The Website may update/amend/modify these Terms of Usage from time to time. The User is responsible to check the Terms of Usage periodically to remain in compliance with these terms."
          }
        ]
      },
      {
        h:"USER CONSENT",
        content:[
          {
            type:"text",
            value:"By accessing the Website and using it, you (“Member”, “You”, “Your”) indicate that you understand the terms and unconditionally & expressly consent to the Terms of Usage of this Website. If you do not agree with the Terms of Usage, please do not click on the “I AGREE” button. The User is advised to read the Terms of Usage carefully before using or registering on the Website or accessing any material, information or services through the Website. Your use and continued usage of the Website (irrespective of the amendments made from time to time) shall signify your acceptance of the terms of usage and your agreement to be legally bound by the same."
          }
        ]
      },
      {
        h:"GENERAL DESCRIPTION",
        content:[
          {
            type:"text",
            value:"The Website is an internet-based portal existing on the World Wide Web, application, and other electronic mediums, providing educational content, reports, data, telephone, video, and email consultations (hereinafter referred to as “Content”). The Website offers “Free Services” and “Paid Services” (collectively referred to as “Services”). Free Services are easily accessible without requiring membership; however, to access personalized educational services, receive additional Content, and gain access to Paid Services, you are required to register as a member on the portal. By registering for Paid Services, a Member agrees to:"
          },
          {
            type:"list",
            value:[
              "Provide current, complete, and accurate information about themselves as prompted by the Website.",

              "Maintain and update the above information as required, ensuring the accuracy and completeness of the information provided."
            ]
          }
        ]
      },
      {
        h:"REGISTRATION AND ELIGIBILITY",
        content:[
          {
            type:"list",
            value:[
              "The User of the Website must be a person who can form legally binding contracts under Indian Contract Act, 1872. A minor under the age of eighteen (18) in most jurisdiction, are not permitted to avail the services provided on the Website without a legal guardian in accordance with the applicable laws. The Website would not be held responsible for any misuse that may occur by virtue of any person including a minor using the services provided through the Website.",

              "For the User to avail the services, the User will be directed to Register as a Member on the Website whereby You (User) agree to provide update, current and accurate information while filling up the sign-in form. All information that you fill and provide to the Website and all updates thereto are referred to in these Terms of Usage as “Registration Data“.",
              
              "An account could be created by you through the Website ID (Your Phone Number) and password (OTP) or other log - in ID and password which can include a facebook, gmail or any other valid email ID. The User while creating an account hereby represents and warrants that all the information provided by the User is current, accurate and complete and that the User will maintain the accuracy and keep the information updated from time to time. Use of another User’s account information for availing the services is expressly prohibited. If in case it is found that the information so supplied on the Website is inaccurate, incomplete, untrue and not current, the Website has the right to suspend or terminate the User’s account and restrict/refuse the use of the Website by such User in future.",

              "The right to use this Website is personal to the User and is not transferable to any other person or entity. The User would be responsible for protecting the confidentiality of User’s passwords and other information required for the purposes of registration. The User would be fully responsible for all the activities that occur under the User’s account with the Website. The Website cannot and will not be liable for any loss or damage arising from the User’s failure to maintain secrecy and confidentiality. The User shall notify the Website immediately if they become aware of any unauthorized use of their Account(s) or breach of any security. The User must log out from its account at the end of the session.",

              "The User while availing any service shall be informed whether the service so rendered is personal to the Website or is available from a Third party. The Website shall have no control or monitoring on the information disseminated to any third party via the Website.",

              "The User agrees, understands and confirms that his/ her personal data including without limitation to details relating to debit card/ credit card transmitted over the Internet may be susceptible to misuse, hacking, theft and/ or fraud and that the Website or the Payment Service Provider(s) have no control over such matters.",
            ]
          },
          {
            type:"list",
            value:[
              {
                text:"The Website does not permit the use of the Services by any User under the following conditions: -",
                children:["If the User is a resident of any jurisdiction that may prohibit the use of the Services rendered by the Website.",

                "If the User is a resident of any State/Country that prohibits by way of law, regulation, treaty or administrative act for entering into trade relations or/and",

                "Due to any religious practices.",

                "If the User has created multiple accounts using various mobile numbers. The User may not have more than one active account with the Website."
                ]
              }
            ]
          },
        ]
      },
      {
        h:"FEATURE “CALL WITH COUNSELOR”",
        content:[
          {
            type:"text",
            value:"The Website is providing certain services which are available through the medium of telecommunication with the counselors listed and enrolled with the Website. By agreeing to the present Terms of Usage, you are also giving your unconditional consent to the Website to arrange a call with you on your mobile number even though your number is on DND service provided by your mobile service provider."
          }
        ]
      },
      {
        h:"WEBSITE CONTENT",
        content:[
          {
            type:"text",
            value:"The Website and any individual websites which may be available through external hyperlinks are private property."
          },
          {
            type:"text",
            value:"All interactions on this Website, including guidance and advice received directly from the licensed providers, must comply with these Terms of Usage."
          },
          {
            type:"text",
            value:"The User shall not post or transmit through this Website any material that violates or infringes in any way upon the rights of others, or any material that is unlawful, abusive, defamatory, invasive of privacy, vulgar, obscene, profane, or otherwise objectionable, which encourages conduct that would constitute a criminal offense, give rise to civil liability, or otherwise violate any law."
          },
          {
            type:"text",
            value:"The Website reserves the right to suspend or terminate access by such User or to terminate the User’s registration, and such User shall not gain access to the Website."
          },
          {
            type:"text",
            value:"The Website reserves the right to change or discontinue any aspect or feature of the Website, including but not limited to content, graphics, deals, offers, settings, etc."
          },
          {
            type:"text",
            value:"Any information other than the guidance and advice received directly from the Third-Party Service Provider, as well as educational content, graphics, research sources, and other incidental information on the Site, should not be considered as medical advice."
          },
          {
            type:"text",
            value:"The Website does not guarantee the medical advice provided by third-party service providers, including registered counselors associated with the site. The User should always consult an appropriately qualified healthcare professional for diagnosis and treatment, including information regarding which medications or treatments may be appropriate for the User. None of the Content represents or warrants that any particular medication or treatment is safe, appropriate, or effective for you. Riso does not endorse any specific tests, medications, products, or procedures."
          },
          {
            type:"text",
            value:"The Website does not guarantee against any untoward incident that may happen to the User after seeking the Service. The Website or the Service Provider providing the advice is not liable and does not guarantee any results as expected by the User, and accessing the Website in such scenarios is purely at the User's risk."
          },
          {
            type:"text",
            value:"By using the Site, Application, or Services, the User hereby agrees that any legal remedy or liability sought for actions or omissions of other Members, including the service providers registered with the Website or other third parties linked to the Website, shall be limited to a claim against such particular party who may have caused any harm. The User agrees not to attempt to impose liability on or seek any legal remedy from the Website concerning such actions or omissions."
          }
        ]
      },
      {
        h:"USER ACCOUNT ACCESS",
        content:[
          {
            type:"text",
            value:"The Website shall have access to the account and the information created by the User for ensuring and maintaining the high-quality services provided by the Website and for addressing the need of the customer in the most effective manner. User hereby consents for the unconditional access of the account by the Website, its employees, agents and other appointed person in such regard. For the purpose of addressing the complaints (if any received) and any suspected abuse reported, the Website shall investigate on case-to-case basis from the records available. The User is directed to read the terms provided in the Privacy Policy as regards such records."
          }
        ]
      },
      {
        h:"PRIVACY POLICY",
        content:[
          {
            type:"text",
            value:"The User hereby consents, expresses and agrees that the User has read and fully understand the Privacy Policy of the Website. The User further consents that the terms and contents of such Privacy policy is acceptable to the User inclusive of any update/alteration/change made and duly displayed on the Website."
          }
        ]
      },
      {
        h:"BREACH AND TERMINATION",
        content:[
          {
            type:"list",
            value:[
              "The Website may, in whole or in part, without informing the User, modify, discontinue, change or alter the services ordered or the Account of the User registered with the Website. The Website may or may not issue notice or provide any reason for such action taken by the Website."
            ]
          },
          {
            type:"list",
            value:[
              {
                text:"Violation of any conditions mentioned in this Terms of Usage shall lead to immediate cancellation of the Registration of the User, if registered with the Website. The Website reserves right to terminate and initiate action immediately, if:",
                children:[
                  "The Website is not able to verify and authenticate the Registration data or any other relevant information provided by the User.",
                  "The Website believes that the actions of the User may cause legal liability for the Website, other Users or any service provider linked with the Website.",
                  "The Website believes that the User has provided the Website with false and misleading Registration Data or there is interference with the other Users or the administration of the services, or have violated the privacy policy as listed by the Website."
                ]
              }
            ]
          },
          {
            type:"list",
            value:[
              "For the Service Provider inclusive of the Astrologer, You understand and agree that your relationship with the Website is limited to being a member and You act exclusively on your own behalf and for your own benefit. The Website may terminate and de-activate the Profile of such service provider for any violation of the present terms of usage and the Service Terms and Conditions agreed upon between the parties while registration of the data by such Service Provider."
            ]
          },
        ]
      },
      {
        h:"DELIVERY, CANCELLATION AND REFUND",
        content:[
          {
            type:"text",
            value:"No refund shall be processed on the order of any reports under any circumstances if the order has reached the “processing” stage (Assigned to a Counselor). The risk and liability of placing an order in haste and carelessly lies entirely with the User, and Riso is not responsible for any refund once the processing stage has started."
          },
          {
            type:"text",
            value:"No refund shall be processed once the Order has been placed and executed. However, if the User intends to cancel a successfully placed order before execution, the User must contact the customer care team within 1 (one) hour of making the payment. Thereafter, it is entirely at the discretion of Riso whether to issue a refund."
          },
          {
            type:"text",
            value:"Any technical delay or glitch reported on the Website during the processing of the request, which includes generating reports by the service provider (i.e., Counselor), shall not be eligible for a refund. The User agrees that the timelines are approximate, and all essential steps will be taken to adhere to the timelines as displayed."
          },
          {
            type:"text",
            value:"No refund shall be processed for reasons that incorrect information or data has been provided by the User. The User agrees to be careful while providing any information to the Website and must re-check the information filled before clicking on “Submit.” The User can request a change in the incorrect information or data entered, provided the request for such change has been made with customer care within 1 (one) hour of the execution of the service rendered by the service provider."
          },
          {
            type:"text",
            value:"No refund shall be processed for the return of any damaged product. The User undertakes and agrees that by ordering any product as displayed on the Website, the Registered User shall be fully responsible for any damage caused to the product post-delivery. For orders made via the “Cash on Delivery” method of payment, the User shall be charged for the cost of the product as displayed by the Website, along with any applicable shipping/custom/courier charges if the product is returned."
          },
          {
            type:"text",
            value:"Refunds, if any, shall be processed after deducting transaction charges levied by the Bank and/or the Payment Gateway, to and from the cost of shipping and/or courier charges (with regard to the purchase of a product listed on the Website), customs duty (if levied), and/or any other charges that may have been incurred by Riso during processing and/or delivering the service, as applicable."
          },
          {
            type:"text",
            value:"In case Riso or the payment gateway’s webpage linked to the Website is experiencing any server-related issues such as ‘slow down,’ ‘failure,’ or ‘session timeout,’ the User shall, before initiating a second payment, check whether their Bank Account has been debited or not and accordingly resort to one of the following options:"
          },
          {
            type:"list",
            value:[
              "If the Bank Account appears to be debited, ensure that you do not make the payment twice and immediately thereafter contact Riso via customer care to confirm payment.",
              "If the Bank Account is not debited, the User may initiate a fresh transaction to make payment."
            ]
          },
          {
            type:"text",
            value:"However, refunds for multiple payments, if any, even after the above precautions against the same order, shall be refunded in full without deduction of the transaction charges as mentioned above. Riso shall only retain the cost of a single order as intended to be placed by the User."
          },
          {
            type:"text",
            value:"If there are orders that Riso is unable to accept and must cancel, Riso reserves the right, at its sole discretion, to refuse or cancel any order for any reason whatsoever. Some situations may result in an order being canceled and include, without limitation, non-availability of the service, inaccuracies, errors in pricing information, or other identified problems. If the User’s order is canceled after charges have been paid against the said service, the said amount paid for booking shall be refunded."
          }

        ]
      },
      {
        h:"USER OBLIGATION",
        content:[
          {
            type:"text",
            value:"The User (including counselors and registered members) is obligated not to violate the privacy policy, terms and conditions, and any other terms defined on the Riso Website. The User represents that they are an individual and not a corporation or other legal business entity. The rights to use Riso’s services are personal to the User. The User shall, while using the Website and engaging in any form of communication on any of the forums, including the products listed on the Website, not violate the following terms and conditions:"
          },

        ]
      },
      {
        h:"1. Content Restrictions",
        content:[
          {
            type:"text",
            value:"The User shall not post, publish, or transmit any messages that are false, misleading, defamatory, harmful, threatening, abusive, harassing, invasive of another's privacy, offensive, or promote racism, hatred, or harm against any individual or group based on religion, caste, or any other characteristic. The User shall also not infringe upon another's rights, including any intellectual property rights or copyright or trademark, or encourage any conduct that would violate applicable law or regulation or give rise to civil liability."
          },
          
        ]
      },
      {
        h:"2. Rights to Content",
        content:[
          {
            type:"text",
            value:"The User shall not upload or post or otherwise make available any content that they do not have the right to make available under any law or under contractual or fiduciary relationships. The User shall not upload or post content that infringes any patent, trademark, trade secret, copyright, or other proprietary rights of any party. However, the User may post excerpts of copyrighted material as long as they adhere to Fair Use guidelines."
          },
          
        ]
      },
      {
        h:"3. Data Collection",
        content:[
          {
            type:"text",
            value:"The User shall not collect screen names and email addresses of registered members for purposes of advertisement, solicitation, or spam."
          },
          
        ]
      },
      {
        h:"4. Unsolicited Communications",
        content:[
          {
            type:"text",
            value:"The User shall not send unsolicited emails, junk mail, spam, chain letters, or promotions or advertisements for products or services."
          },
          
        ]
      },
      {
        h:"5. Malicious Software",
        content:[
          {
            type:"text",
            value:"The User shall not upload or distribute files that contain viruses, corrupted files, or any other similar software or programs that may damage the operation of the Website or another’s computer."
          },
          
        ]
      },
      {
        h:"6. Interference",
        content:[
          {
            type:"text",
            value:"The User shall not engage in any activity that interferes with or disrupts access to the Website."
          },
          
        ]
      },
      {
        h:"7. Unauthorized Access",
        content:[
          {
            type:"text",
            value:"The User shall not attempt to gain unauthorized access to any portion or feature of the Website, any systems or networks connected to the Website, or any of the services offered on or through the Website by hacking, password mining, or any other illegitimate means."
          },
          
        ]
      },
      {
        h:"8. Compliance with Laws",
        content:[
          {
            type:"text",
            value:"The User shall not violate any applicable laws or regulations in force within or outside India. The use of the Website is subject to using the services for personal use only."
          },
          
        ]
      },
      {
        h:"9. Commercial Use",
        content:[
          {
            type:"text",
            value:"The User shall not resell or make any commercial use of the Services without the express written consent from Riso."
          },
          
        ]
      },
      {
        h:"10. Terms of Usage",
        content:[
          {
            type:"text",
            value:"The User shall not violate these Terms of Usage, including any applicable additional terms of the Website."
          },
          
        ]
      },
      {
        h:"11. Prohibited Actions",
        content:[
          {
            type:"text",
            value:"The User shall not reverse engineer, modify, copy, distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer, or sell any information or software obtained from the Website."
          },
          
        ]
      },
      {
        h:"12. User Agreement",
        content:[
          {
            type:"text",
            value:"By becoming a registered member of the Website, the User agrees to the following, which is not an exhaustive list and may include services incidental to the following:"
          },
          {
            type:"list",
            value:[
              "The User agrees to receive certain specific emails and SMS along with calls from Riso.",
              "The User agrees not to transmit any unlawful, harassing, libelous, abusive, threatening, harmful, vulgar, obscene, or otherwise objectionable material of any kind via the Website.",
              "The User shall not transmit any material that encourages conduct that could constitute a criminal offense, give rise to civil liability, or otherwise violate any applicable local, state, national, or international law or regulation. Attempts to gain unauthorized access to other computer systems are prohibited.",
              "The User shall not interfere with any other members' use or enjoyment of the Website or Services."
            ]
          }
          
        ]
      },
      {
        h:"13. Reporting Misuse",
        content:[
          {
            type:"text",
            value:"TThe User is obligated to report any misuse or abuse of the Site. If the User notices any abuse or misuse of the Site or anything in violation of this Agreement, they shall immediately report such violation to Riso by writing to Customer Care. Upon receipt of such a complaint, Riso may investigate the matter and, if necessary, terminate the membership of the member responsible for such violation, abuse, or misuse without any refund of the subscription fee."
          },
          
        ]
      },
      {
        h:"14. False Complaints",
        content:[
          {
            type:"text",
            value:"Any false complaint made by a member shall make that member liable for termination of their membership without any refund of the subscription fee."
          },
          
        ]
      },
      {
        h:"15. Customer Conduct",
        content:[
          {
            type:"text",
            value:"MentorX4u reserves the right to withdraw its services from any customer found to be unreasonable or abusive during their conversation with the service provider, including counselors, regardless of the reason."
          },
          
        ]
      },
      {
        h:"16. Response to Violations",
        content:[
          {
            type:"text",
            value:"While Riso will take all necessary steps to resolve any situation that violates these obligations, if a situation arises that is uncontrollable, Riso reserves the right to issue a written warning. Repeated violations by the User shall lead to a total ban on transacting on the platform. If any balance is present in the User's wallet, it shall be refunded, subject to any applicable charges for such violations."
          },
          
        ]
      },
      {
        h:"BANK ACCOUNT INFORMATION",
        content:[
          {
            type:"text",
            value:"The User is under an obligation to provide his banking information as and when required. For that purpose, the obligation of the User are:-"
          },
          {
            type:"list",
            value:["The User agrees that the debit/credit card details provided by him/ her for use of the aforesaid Service(s) must be correct and accurate and that the User shall not use a debit/ credit card, that is not lawfully owned by him/ her or the use of which is not authorized by the lawful owner thereof. The User further agrees and undertakes to provide correct and valid debit/credit card details."]
          },
          {
            type:"list",
            value:[
              {
                text:"The User may pay the fees required, to the Website by using a debit/credit card or through online banking account. The User warrants, agrees and confirms that when he/ she initiates a payment transaction and/or issues an online payment instruction and provides his/ her card / bank details:",
                children:[
                  "The User is fully and lawfully entitled to use such credit / debit card, bank account for such transactions;",
                  "The User is responsible to ensure that the card/ bank account details provided by him/ her are accurate;"
                ]
              }
            ]
          },
          {
            type:"list",
            value:["The User is responsible to ensure sufficient credit is available on the nominated card/ bank account at the time of making the payment to permit the payment of the dues payable or the bill(s) selected by the User inclusive of the applicable Fee."]
          },
          {
            type:"text",
            value:"The User further agrees that if any part of these Terms of Usage are determined to be invalid or unenforceable pursuant to applicable law including, but not limited to, the warranty disclaimers and liability limitations set forth herein, then the invalid or unenforceable provision will be deemed superseded by a valid, enforceable provision that most closely matches the intent of the original provision and the remainder of these Terms of Usage shall continue in effect."
          },
          
        ]
      },
      {
        h:"DISCLAIMER / LIMITATION OF LIABILITY / WARRANTY",
        content:[
          {
            type:"text",
            value:"The User expressly understands and agrees that, to the maximum extent permitted by applicable law, Riso does not provide warranties for its services. Counseling provided through the Riso platform is based on the cumulative or individual knowledge, experience, and interpretations of counselors and may vary from one counselor to another."
          },
          {
            type:"text",
            value:"Riso offers services through a diverse panel of verified counselors. These counselors may, from time to time, make recommendations for using various remedies, such as tools or products related to education and career guidance. Such recommendations are made in good faith by the counselors, and Riso and its subsidiaries, affiliates, officers, employees, agents, partners, and licensors make no warranty that:"
          },
          {
            type:"list",
            value:[
              "The service will meet your requirements",
              "The service will be uninterrupted, timely, secure, or error-free.",
              "The service will be uninterrupted, timely, secure, or error-free.",
              "The results obtained from the use of the service will be accurate or reliable.",
              "The quality of any products, services, information, or other material purchased or obtained by you through the service will meet your expectations.",
              "Any errors in the software will be corrected."
            ]
          },
          {
            type:"text",
            value:"Users are required to fully disclose their emotional, mental, and physical state when seeking advice from Riso counselors so that informed judgments can be made."
          },
          {
            type:"text",
            value:`The Website, services, and other materials are provided on an "as is" basis without warranty of any kind, express, implied, statutory, or otherwise, including the implied warranties of title, non-infringement, merchantability, or fitness for a particular purpose. Without limiting the foregoing, Riso makes no warranty that:`
          },
          {
            type:"list",
            value:[
              "The Website or services will meet your requirements or that your use of the Website or services will be uninterrupted, timely, secure, or error-free.",
              "The results obtained from the use of the Website, services, or materials will be effective, accurate, or reliable.",
              "The quality of the Website, services, or other materials will meet your expectations.",
              "Any errors or defects in the Website, services, or other materials will be corrected."
            ]
          },
          {
            type:"text",
            value:"No advice or information, whether oral or written, obtained by the User from Riso or through or from the use of the services shall create any warranty not expressly stated in the terms of use."
          },
          {
            type:"text",
            value:"To the maximum extent permitted by applicable law, Riso will have no liability related to User content arising under intellectual property rights, libel, privacy, publicity, obscenity, or other laws. Riso also disclaims all liability with respect to the misuse, loss, modification, or unavailability of any User content."
          },
          {
            type:"text",
            value:"Riso will not be liable for any loss that the User may incur as a consequence of unauthorized use of their account or account information in connection with the Website or any services or materials, whether with or without the User’s knowledge. Riso has endeavored to ensure that all information on the Website is correct, but it neither warrants nor makes any representations regarding the quality, accuracy, or completeness of any data, information, product, or service. Riso shall not be responsible for the delay or inability to use the Website or related functionalities, the provision of or failure to provide functionalities, or for any information, software, products, functionalities, and related graphics obtained through the Website, or otherwise arising out of the use of the Website, whether based on contract, tort, negligence, strict liability, or otherwise. Furthermore, Riso shall not be held responsible for the unavailability of the Website during periodic maintenance operations or any unplanned suspension of access to the Website that may occur due to technical reasons or for any reason beyond Riso's control."
          },
          {
            type:"text",
            value:"The User understands and agrees that any material or data downloaded or otherwise obtained through the Website is done entirely at their own discretion and risk, and they will be solely responsible for any damage to their computer systems or loss of data that results from the download of such material or data. Riso is not responsible for any typographical error leading to an invalid coupon. Riso accepts no liability for any errors or omissions with respect to any information provided to you, whether on behalf of itself or third parties."
          },
          {
            type:"text",
            value:"The services provided by Riso are for informational purposes only, and Riso, on behalf of itself and its suppliers, disclaims all warranties of any kind, express or implied, including without limitation any warranty of merchantability, fitness for a particular purpose, title, or non-infringement. It makes no warranty or representation regarding the results that may be obtained from the use of content or services, the accuracy or reliability of any content obtained through the services, or any goods or services purchased or obtained through the Website, and makes no warranty that the services will meet your requirements, be uninterrupted, timely, secure, or error-free. No advice or information, whether oral or written, obtained by you from Riso shall create any warranty."
          },
          {
            type:"text",
            value:"The services may consist of, without limitation: educational content, reports, consultations, or products sold through the Riso platform. Riso charges for chat or call services offered on this platform on a per-minute basis and holds no responsibility or liability regarding the accuracy or reliability of any effects on educational or career outcomes related to any products or services represented and sold on the Website. No advice or information, whether oral or written, obtained by you shall create any warranty."
          },
          {
            type:"text",
            value:"The advisors/counselors are also members of the site and not employees of Riso. However, Riso verifies the degrees, qualifications, credentials, and backgrounds of the advisors/counselors but does not refer, endorse, recommend, verify, evaluate, or guarantee any advice, information, or other services provided by the advisors/counselors or by the company, nor does it warrant the validity, accuracy, completeness, safety, legality, quality, or applicability of the content or any advice provided by the advisors/counselors."
          },
          {
            type:"text",
            value:"Riso is not a mental health support platform. If you are considering or contemplating self-harm or feel that you are a danger to yourself or others, you may discontinue use of the services immediately at your discretion and please notify appropriate authorities or emergency medical personnel. If you are in crisis, please reach out to a crisis hotline or mental health professional."
          },
          {
            type:"text",
            value:"Riso shall not be liable for any inaccuracy, error, delay, or omission of (a) any data, information, or message; (b) the transmission or delivery of any such data, information, or message; or (c) any loss or damage arising from or occasioned by any such inaccuracy, error, delay, or omission, non-performance, or interruption in any such data, information, or message. Under no circumstances shall Riso and/or the payment service providers, its employees, directors, and third-party agents involved in processing, delivering, or managing the services, be liable for any direct, indirect, incidental, special, or consequential damages, or any damages whatsoever, including punitive or exemplary damages arising out of or in any way connected with the provision of, or any inadequacy or deficiency in, the provision of the services or resulting from unauthorized access or alteration of transmissions of data or arising from suspension or termination of the services."
          },
          {
            type:"text",
            value:"Notwithstanding anything to the contrary contained herein, Riso's liability to you for any cause whatsoever, and regardless of the form of the action, will at all times be limited to the amount paid, if any, by you to Riso for the service during the term of membership."
          },

        ]
      },
      {
        h:"INDEMNIFICATION",
        content:[
          {
            type:"text",
            value:"The User shall indemnify, defend and hold harmless the Website and its parent, subsidiaries, affiliates, officers, directors, employees, suppliers, consultants and agents from any and all third party claims, liability, damages and/or costs (including, but not limited to, attorney’s fees) arising from Your use of the Services, Your violation of the Privacy Policy or these Terms of Service, or Your violation of any third party's rights, including without limitation, infringement by You or any other user of Your account of any intellectual property or other right of any person or entity. These Terms of Service will inure to the benefit of Website’s successors, assigns, and licensees."
          }
        ]
      },
      {
        h:"PROPRIETARY RIGHTS TO CONTENT",
        content:[
          {
            type:"text",
            value:"The User acknowledges that the Content, including but not limited to text, software, music, sound, photographs, video, graphics, or other material contained in sponsor advertisements or distributed via email, as well as commercially produced information presented to Users by Riso, its suppliers, and/or advertisers, is protected by copyrights, trademarks, service marks, patents, and/or other proprietary rights and laws. The User is not permitted to copy, use, reproduce, distribute, perform, display, or create derivative works from the Content unless expressly authorized by Riso, its suppliers, or advertisers."
          },
          {
            type:"text",
            value:"Furthermore, the content such as images, text, designs, etc., on all portals of Riso are sourced from various online platforms, including Google Images. Riso is not liable for any copyrights associated with that content or data."
          }
        ]
      },
      {
        h:"NOTICES",
        content:[
          {
            type:"text",
            value:"Except as otherwise stated in these Terms of Service, all notices to a party shall be in writing and shall be made either via email or postal mail. Notice shall be deemed given 24 hours after an email is sent, or 3 days after deposit in postal mail, to the User at the address provided by the User in the Registration Data and to Riso at the address set forth below:"
          },
          {
            type:"text",
            value:"Alkapuri Cmplx Khodasingi Engineering School, Brahmapur Sadar Ganjam, Odisha, 760010 India."
          }
        ]
      },
      {
        h:"GOVERNING LAW AND JURISDICTION",
        content:[
          {
            type:"list",
            value:[
              "Any dispute, claim or controversy arising out of or relating to this Terms of Usage including the determination of the scope or applicability of this Terms of Usage to arbitrate, or your use of the Application or information to which it gives access, shall be determined by arbitration in India, before a sole arbitrator mutually appointed by Members and Website. Arbitration shall be conducted in accordance with the Arbitration and Conciliation Act, 1996. The seat of such arbitration shall be New Delhi. All proceedings of such arbitration, including, without limitation, any awards, shall be in the English language. The award shall be final and binding on the parties to the dispute.",

              "Notwithstanding the foregoing, either party has the right to seek any interim or preliminary relief from a court of competent jurisdiction in New Delhi in order to protect the rights of such party pending the completion of any arbitration hereunder, and both parties agree to submit to the exclusive jurisdiction of the courts of India and venue in New Delhi for any such proceeding. If either party files an action contrary to this provision, the other party may recover attorneys' fees and costs up to One Lakh Rupees INR.",

              "These Terms of Usage shall be governed by and construed in accordance with the laws of India without giving effect to any choice of law and principles that would require the application of the laws of a different state. If for any reason a court of competent jurisdiction finds any provision or portion of these Terms of Usage or Privacy Policy to be unenforceable or invalid, such provision shall be changed and interpreted so as to best accomplish the objectives of such unenforceable or invalid provision within the limits of applicable law, and the remainder of the Terms of Usage or Privacy Policy, as applicable, will continue in full force and effect. Headings are for reference purposes only and in no way define, limit, construe, or describe the scope or extent of such section. Any waiver of any provision of the Terms of Usage shall be effective only if in writing and signed by Astrotalk. These Terms of Usage constitute the entire agreement between the parties with respect to the subject matter hereof and supersedes and replaces all prior or contemporaneous understandings or agreements, written or oral, regarding such subject matter.",

              "These Terms of Usage and your use of the Services will be interpreted in accordance with the laws of India excluding its rules on conflicts of laws. The parties agree to submit any dispute arising under these Terms of Usage to the jurisdiction of a court located in New Delhi for any actions for which the parties retain the right to seek injunctive or other equitable relief in a court of competent jurisdiction to prevent the actual or threatened infringement, misappropriation or violation of a party's copyrights, trademarks, trade secrets, patents, or other intellectual property rights."
            ]
          }
        ]
      }
    ]
  },
  fraud:{
    title:"Fraud Alert",
    img:fraudBanner,
    topics:[
      {
        h:"Dear MentorX4u Users,",
        content:[
          {
            type:"text",
            value:"We want to ensure that your experience with MentorX4u is safe and secure. Please be vigilant and aware of potential fraud attempts that may target users of our platform."
          }
        ]
      },
      {
         h:"Common Fraud Scenarios:",
        content:[
          {
            type:"list",
            value:[
              "Phishing Emails: Be cautious of unsolicited emails claiming to be from MentorX4u. These emails may ask for personal information or direct you to a fraudulent website. Always verify the sender’s email address.",

              "Unauthorized Transactions: Monitor your accounts for any unauthorized transactions or suspicious activity. If you notice anything unusual, please report it immediately.",

              "Impersonation Attempts: Fraudsters may impersonate MentorX4u staff or representatives to gain access to your personal information. Always verify the identity of anyone requesting sensitive information.",

              "Job Offers and Recruitment Scams: Be wary of job offers that seem too good to be true, especially those requesting payment or personal information upfront. MentorX4u will never ask for payment in exchange for a job offer."
            ]
          }
        ]
      },
      {
         h:"What You Can Do:",
        content:[
          {
            type:"list",
            value:[
              "Verify Information: If you receive any communication that seems suspicious, please verify by contacting our support team directly through official channels.",

              "Protect Your Information: Never share your account details, passwords, or personal information with anyone.",

              "Report Suspicious Activity: If you encounter any fraudulent activity or have concerns, please report it to us immediately at [support@MentorX4u.com].",

              "Job Offers and Recruitment Scams: Be wary of job offers that seem too good to be true, especially those requesting payment or personal information upfront. MentorX4u will never ask for payment in exchange for a job offer."
            ]
          },
          {
            type:"text",
            value:[
              {type:"bold",text:"Stay Safe!"},
              "Your security is our priority. We are committed to protecting your personal information and ensuring a safe platform for all users."
            ]
          },
          {
            type:"text",
            value:"Thank you for being a valued member of the MentorX4u community."
          },
          {
            type:"text",
            value:[
              {type:"bold",text:"Best Regards,"}
            ]
            
          },
          {
            type:"text",
            value:"The MentorX4u Team"
          }
        ]
      }
    ]
  },
  trust:{
    title:"Trust & Sefty",
    img:trustBanner,
    topics:[
      {
        h:"Trust and Safety at MentorX4u",
        content:[
          {
            type:"text",
            value:"At MentorX4u, the safety and security of our users are our top priorities. We are committed to creating a trusted environment where users can engage with our services confidently. Here’s how we ensure your safety while using our platform:"
          }
        ]
      },
      {
        h:"1. Data Protection",
        content:[
          {
            type:"text",
            value:"We implement robust security measures to protect your personal information from unauthorized access, loss, or misuse. Our practices are in line with industry standards and comply with applicable data protection laws"
          }
        ]
      },
      {
        h:"2. Privacy Policy",
        content:[
          {
            type:"text",
            value:"We respect your privacy and are transparent about how we collect, use, and protect your personal data. Our Privacy Policy outlines our practices, including your rights regarding your personal information."
          }
        ]
      },
      {
        h:"3. User Verification",
        content:[
          {
            type:"text",
            value:"To maintain a safe community, we may implement verification processes for user accounts. This helps us ensure that our users are who they say they are, reducing the risk of fraudulent activity."
          }
        ]
      },
      {
        h:"4. Reporting Mechanisms",
        content:[
          {
            type:"text",
            value:"If you encounter any suspicious behavior or believe that your safety is at risk, we encourage you to report it. Our dedicated support team is available to address your concerns promptly and effectively."
          }
        ]
      },
      {
        h:"5. Educational Resources",
        content:[
          {
            type:"text",
            value:"We provide resources and tips to help our users recognize and avoid potential fraud, scams, and other risks. Stay informed and empowered to protect yourself online."
          }
        ]
      },
      {
        h:"6. Continuous Improvement",
        content:[
          {
            type:"text",
            value:"We are constantly reviewing and updating our security protocols to address emerging threats. Our commitment to trust and safety is ongoing, and we welcome feedback from our community to improve our practices."
          }
        ]
      },
      {
        h:"Your Safety Matters",
        content:[
          {
            type:"text",
            value:"At MentorX4u, we believe that a safe and secure environment is essential for fostering trust and engagement among our users. We are dedicated to safeguarding your information and providing you with a positive experience on our platform."
          },
          {
            type:"text",
            value:"If you have any questions or concerns about trust and safety, please feel free to reach out to us at [support@MentorX4u.com]. Together, we can create a safer online community."
          }
        ]
      },
      
    ]
  },
  report:{
    title:"Report Issue",
    img:reportBanner,
    topics:[
      {
        h:"Topic",
        content:[
          {
            type:"text",
            value:"Please select the category that best describes your issue so we can resolve it quickly."
          },
           {
            type:"text",
            value:"Common topics include:"
          },
            {
            type:"list",
            value:[
              "Payment & Billing Issues",
              "Session Connectivity Problems",
              "Mentor Behavior or Misconduct",
              "App Technical Errors",
              "Refund & Wallet Issues",
              "Account Access Problems",
              "Other Support Requests"
            ]
          },
        ],
      },
      {
        h:"Report Description",
        content:[
          {
            type:"text",
            value:"Describe your issue clearly with relevant details such as:"
          },
        
            {
            type:"list",
            value:[
              "Date and time of the issue",
              "Mentor or session name (if applicable)",
              "Screenshot or error message (if any)",
              "Transaction ID (for payment issues)",
            ]
          },
             {
            type:"text",
            value:"Providing accurate information helps us investigate faster."
          },
        ], 
      }, 
      {
        h:"Your Safety Matters",
        content:[
          {
            type:"text",
            value:"All reports are handled confidentially by our Trust & Safety team. We ensure fair investigation and take necessary action when required."
          },
        ], 
      }, 
        {
        h:"Resolution Timeline",
        content:[
          {
            type:"text",
            value:"Most issues are reviewed within 24–48 hours. You will receive updates through app notifications or email."
          },
        ], 
      },
       {
        h:"Need Immediate Help?",
        content:[
          {
            type:"text",
            value:"For urgent concerns, please contact our support team via the Help section."
          },
        ], 
      },
    ]
  },
  help:{
    title:"Help",
    img:helpBanner,
    topics:[
      {
        h:"Topic",
        content:[
          {
            type:"text",
            value:"Select the area where you need assistance so we can guide you quickly."
          },
          {
            type:"text",
            value:"Popular help topics include:"
          },
            {
            type:"list",
            value:[
              "Getting Started with MentorX",
              "Booking & Managing Sessions",
              "Wallet, Coins & Payments",
              "Profile & Account Settings",
              "Technical Support",
              "Mentor Selection",
              "Feedback & Suggestions"
            ]
          },
        ]
      },
      {
        h:"Help & Support Guide",
        content:[
          {
            type:"text",
            value:"Welcome to MentorX Help Center. We are here to make your learning and mentoring experience smooth and hassle-free."
          },
          {
            type:"text",
            value:"In this section, you can:"
          },
            {
            type:"list",
            value:[
              "Learn how to use app features",
              "Understand policies and guidelines",
              "Resolve common issues",
              "Get step-by-step support",
              "Contact our support team",
            ]
          },
              {
            type:"text",
            value:"Our goal is to provide fast, clear, and reliable assistance whenever you need it."
          },
        ]
      },
      {
        h:"Quick Tips",
        content:[
            {
            type:"list",
            value:[
              "Check FAQs before raising a ticket",
              "Keep your app updated",
              "Ensure stable internet for sessions",
              "Save payment receipts",
            ]
          },
              {
            type:"text",
            value:"Our goal is to provide fast, clear, and reliable assistance whenever you need it."
          },
        ]
      },
           {
        h:" Still Need Help?",
        content:[
            {
            type:"text",
            value: "If you can’t find your answer here, please contact us through the Report Issue section. Our support team will assist you within 24 hours."
          },
        ]
      }
    ]
  }
};

export default sections;